import { render, staticRenderFns } from "./EndorsementGrid.vue?vue&type=template&id=206f51d0&scoped=true&"
import script from "./EndorsementGrid.vue?vue&type=script&lang=js&"
export * from "./EndorsementGrid.vue?vue&type=script&lang=js&"
import style0 from "./EndorsementGrid.vue?vue&type=style&index=0&id=206f51d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206f51d0",
  null
  
)

export default component.exports